export default __webpack_public_path__ + "alberta-shoppingcart-square-full.10b89f6c3d1b3d0dfaba.svg";